import type { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

interface CreativesEmptyStateProps {
  hasActiveFilters: boolean;
  onClearFilters?: () => void;
}

const CreativesEmptyState: FC<CreativesEmptyStateProps> = ({
  hasActiveFilters,
  onClearFilters,
}) => {
  const Icon = hasActiveFilters ? SearchOffIcon : InboxOutlinedIcon;
  const title = hasActiveFilters
    ? 'No creatives match your filters'
    : 'No test creatives yet';
  const description = hasActiveFilters
    ? 'Try adjusting or clearing the filters to see more results.'
    : 'Once test creatives are uploaded, they will appear here.';

  return (
    <Box
      role="status"
      sx={(t) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 6,
        px: 3,
        border: '1px dashed',
        borderColor: t.palette.divider,
        borderRadius: 2,
        textAlign: 'center',
      })}
    >
      <Icon sx={(t) => ({ fontSize: 48, color: t.palette.text.disabled })} />
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
        {description}
      </Typography>
      {hasActiveFilters && onClearFilters && (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={onClearFilters}
          sx={{ mt: 1 }}
        >
          Clear filters
        </Button>
      )}
    </Box>
  );
};

export default CreativesEmptyState;
